import { Stack, Typography } from '@mui/material';

import { Icon } from '@hapvida/hapvida-core-components';

import { IconBox, Value } from '../../styles';
import { SummaryItemProps } from './types';

export const SummaryItem = ({
  iconName,
  bgColor,
  iconColor,
  textColor,
  value,
  label,
  ...rest
}: SummaryItemProps) => {
  return (
    <Stack gap={2} direction="row" width="100%" alignItems="center" {...rest}>
      <IconBox color={bgColor}>
        <Icon name={iconName} color={iconColor} />
      </IconBox>
      <Stack direction="column">
        <Value color={textColor}>{value}</Value>
        <Typography fontWeight={400} variant="text">
          {label}
        </Typography>
      </Stack>
    </Stack>
  );
};
